import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "../App";
import "../App.css";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AllProviders } from "./providers/AllProviders";
// If injected at the wrong time, this overrides our CSS
import "stream-chat-react/dist/css/index.css";
import "../styles/stream-chat-react.css";

export const Layout = () => {
  return (
    <AllProviders>
      {/*  Mount toasts on the same place for every page */}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        closeOnClick
        hideProgressBar={false}
        pauseOnHover
      />
      <App />
      {/* Add ReactQueryDevTools after the app */}
      <ReactQueryDevtools initialIsOpen={false} />
    </AllProviders>
  );
};
